module.exports = __webpack_public_path__ + "img/feature-5.2d02d3f6.png";